module.exports = __webpack_public_path__ + "static/img/about3.1f34a62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about3.png
// module id = yTCO
// module chunks = 1